module.exports = __webpack_public_path__ + "static/media/star2.1c7a6962.svg";